"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const useOsmosysContext_1 = require("../../hooks/useOsmosysContext");
exports.AdminOnly = ({ children, fallback, workspaceAdminsAlso, }) => {
    const { adminRole, currentUser } = useOsmosysContext_1.useOsmosysContext();
    const show = currentUser &&
        (adminRole === 'app' || (workspaceAdminsAlso && adminRole === 'workspace'));
    return (react_1.default.createElement(Inner, { fallback: fallback, show: show }, children));
};
const Inner = ({ children, fallback, show }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, show ? children : fallback || null);
};
//# sourceMappingURL=AdminOnly.js.map